import React, { createContext, useContext } from 'react';
import type { FC, PropsWithChildren } from 'react';
import { useFragment } from 'react-relay';

import {
	type FabricEligibilityFragmentData,
	type FabricEligibilityFragmentRef,
	UseFabricEligibilityMigrationFragment,
} from './useFabricEligibilityMigrationQuery.ts';

const FabricEligibilityFragmentContext = createContext<FabricEligibilityFragmentData>(null);

type FabricEligibilityFragmentProviderProps = PropsWithChildren<{
	contentFragmentRef?: FabricEligibilityFragmentRef | null;
}>;

type FabricEligibilityFragmentReaderProps = PropsWithChildren<{
	contentFragmentRef: FabricEligibilityFragmentRef;
}>;

const FabricEligibilityFragmentReader: FC<FabricEligibilityFragmentReaderProps> = ({
	contentFragmentRef,
	children,
}) => {
	const contentFragmentData = useFragment(
		UseFabricEligibilityMigrationFragment,
		contentFragmentRef,
	);

	return (
		<FabricEligibilityFragmentContext.Provider value={contentFragmentData}>
			{children}
		</FabricEligibilityFragmentContext.Provider>
	);
};

export const FabricEligibilityFragmentProvider: FC<FabricEligibilityFragmentProviderProps> = ({
	contentFragmentRef,
	children,
}) => {
	if (!contentFragmentRef) {
		return (
			<FabricEligibilityFragmentContext.Provider value={null}>
				{children}
			</FabricEligibilityFragmentContext.Provider>
		);
	}

	return (
		<FabricEligibilityFragmentReader contentFragmentRef={contentFragmentRef}>
			{children}
		</FabricEligibilityFragmentReader>
	);
};

export const useFabricEligibilityFragment = (): FabricEligibilityFragmentData =>
	useContext(FabricEligibilityFragmentContext);
